<template>
    <div id="offline-detection-block" class="marquee" v-if="!onLine">
      <p>LET OP: Geen internetverbinding &bull; Je kunt de analyse wel opslaan en later versturen &bull; Deze melding verdwijnt automatisch zodra er weer verbinding is</p>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        onLine: navigator.onLine
      }
    },
    methods: {
      updateOnlineStatus(e) {
        const { type } = e
        this.onLine = type === 'online'
      }
    },
    mounted() {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
    },
    beforeDestroy() {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    }
  }
</script>

<style>
  #offline-detection-block {
    text-align: center;
    background-color: red;
    /* display: none; */
    position: fixed;
    color: white;
    white-space: nowrap;
    bottom: 0;
    width: 100%;
    height: 26px;
    color: white;
    font-weight: bold;
    overflow: hidden;
    margin-bottom:6px;
    font-size:14px;
    z-index:99999;
  }

.marquee p {
    display: inline-block;
    padding-left: 100%;
    animation: marquee 30s linear infinite;
    color:white;
    line-height:26px;
}
@keyframes marquee {
    0%   { transform: translate(0, 0); }
    100% { transform: translate(-100%, 0); }
}
</style>
